// extracted by mini-css-extract-plugin
export default {"menuButtons":"menuButtons___Ko2G7","menuButtons_title":"menuButtons_title___YvR1a"};